import { Link } from "react-router-dom";
import {
  AppLogoSizeOverride,
  useAppLogoAsset,
} from "@shared/hooks/useAppLogoAsset";
import { LogoContainer } from "./styles";

type Props = {
  hide?: boolean;
  disabled?: boolean;
  size?: AppLogoSizeOverride;
  padding?: string;
};

export const AppLogo = (props: Props) => {
  const { disabled, hide = false, size, padding = "0 1rem" } = props;
  const { src, alt, height } = useAppLogoAsset("blue", size);

  return (
    <LogoContainer
      aria-disabled={disabled}
      style={{
        opacity: hide ? 0 : 1,
        pointerEvents: hide ? "none" : "auto",
        padding,
      }}
      $imgHeight={height}
    >
      <Link to="/">
        <img src={src} alt={alt} />
      </Link>
    </LogoContainer>
  );
};
